// Hooks
import { useFlag } from '@sketch/modules-common'
import { useHideCollectionsSetting } from './useHideCollectionsSetting'

// GraphQL
import { useGetProjectCollectionsQuery } from '@sketch/gql-types'

// Types
import { ShareSearchFilter } from 'modules/shares/hooks/useSearchFilters'

interface UseGetProjectCollectionsProps {
  projectIdentifier: string
  filters: ShareSearchFilter[]
  searchTerm?: string
}

export const useGetProjectCollections = ({
  projectIdentifier,
  filters,
  searchTerm,
}: UseGetProjectCollectionsProps) => {
  const isSearchFilterSortOn = useFlag('search-filter-sort')

  const { hideCollections } = useHideCollectionsSetting()

  const hasSearchCriteria = !!searchTerm || filters.length > 0

  const skip =
    (!isSearchFilterSortOn && hasSearchCriteria) ||
    (isSearchFilterSortOn && hideCollections)

  const search =
    isSearchFilterSortOn && hasSearchCriteria
      ? { name: searchTerm ?? null, filters }
      : undefined

  return useGetProjectCollectionsQuery({
    variables: {
      projectIdentifier,
      search,
      after: null,
    },
    shouldInvalidatePrevious: (prev, curr) =>
      prev?.projectIdentifier !== curr?.projectIdentifier,
    skip,
  })
}
